var map = {
	"./color/franken-zap.png": 1442,
	"./color/franken.png": 1443,
	"./color/frankensheet-extruded.png": 1444,
	"./color/frankensheet.png": 1445,
	"./color/mess.png": 1446,
	"./color/shopkeeper.png": 1447,
	"./color/shopper1.png": 1448,
	"./color/shopper2.png": 1449,
	"./color/shopper3.png": 1450,
	"./gameboy/franken-zap.png": 1451,
	"./gameboy/franken.png": 1452,
	"./gameboy/frankensheet-extruded.png": 1453,
	"./gameboy/frankensheet.png": 1454,
	"./gameboy/mess.png": 1455,
	"./gameboy/shopkeeper.png": 1456,
	"./gameboy/shopper1.png": 1457,
	"./gameboy/shopper2.png": 1458,
	"./gameboy/shopper3.png": 1459,
	"./info.png": 532,
	"./mute.png": 533,
	"./theme.png": 534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1441;